import { IoClose } from 'react-icons/io5';
import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@ds';

export type DeviceDeliveryInfoModalProps = {
  isOpen: boolean;
  message: string;
  size?: 'md' | 'xs' | 'sm' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | 'full';
  onClose: () => void;
};

export const DeviceDeliveryInfoModal = ({ isOpen, size = '3xl', message, onClose }: DeviceDeliveryInfoModalProps) => {
  return (
    <Modal
      size={size}
      isOpen={isOpen}
      onClose={onClose}
      backdrop="opaque"
      closeButton={<IoClose size={45} style={{ top: 15, right: 15 }} />}
      classNames={{
        base: 'px-6',
        body: 'border-y-1 border-base-30 px-0 py-6 text-s-r text-base-20',
        header: 'px-0 font-secondary text-hl! text-base-20',
        footer: 'px-0 flex gap-6',
        wrapper: 'z-420',
        backdrop: 'z-419',
      }}
    >
      <ModalContent>
        {(handleClose) => (
          <>
            <ModalHeader>Device return to NOP Hub</ModalHeader>
            <ModalBody>{message}</ModalBody>
            <ModalFooter>
              <Button size="sm" variant="solid" onPress={handleClose}>
                Close
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};
